import { useMemoizedFn } from "ahooks";
import type React from "react";
import { type RefObject } from "react";

export type UseSenderEnterSubmitParams = {
  isComposingRef: RefObject<boolean>;
  /** If false, Enter does not submit (e.g. readOnly) */
  shouldAllowEnterSubmit?: boolean;
  /**
   * Called when user presses Enter (not Shift) outside composition.
   * Typically: sync textarea → ref, then trySend / onSend.
   */
  onEnter: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
};

/**
 * Enter to submit, Shift+Enter for newline; respects IME composition.
 */
export function useSenderEnterSubmit({
  isComposingRef,
  shouldAllowEnterSubmit,
  onEnter,
}: UseSenderEnterSubmitParams) {
  const onKeyDown = useMemoizedFn(
    (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      const canSubmit =
        e.key === "Enter" && !isComposingRef.current && !e.shiftKey;
      if (!canSubmit) {
        return;
      }
      if (!shouldAllowEnterSubmit) {
        return;
      }
      e.preventDefault();
      onEnter(e);
    },
  );

  return { onKeyDown };
}
